import React, { Component } from 'react';

import { DeploymentEditor } from '../../components/Deployment';

function DeploymentEditorPage({ match }) {
	return <DeploymentEditor />;
}

export default DeploymentEditorPage;
